<template>
  <div class="contractFile">
    <!-- 顶部导航栏，便于返回文件列表 -->
    <toptitle :title1="title" />
    <!-- PDF 预览区域 -->
    <div class="pdf-wrap">
      <iframe
        v-if="fileUrl"
        class="pdf-iframe"
        :src="fileUrl"
        frameborder="0"
        @load="handleIframeLoad"
      />
      <!-- 加载遮罩：iframe 加载完成或请求异常后隐藏 -->
      <div v-if="loading" class="loading-mask">
        <van-loading type="circle" color="#1989fa" size="32">文件加载中...</van-loading>
      </div>
    </div>
  </div>
</template>

<script>
import toptitle from '../components/toptitle';
import { getContractFile } from '../request/api';
import { Toast } from 'vant';

export default {
  name: 'contractFile',
  components: {
    toptitle
  },
  data() {
    return {
      title: '合同文件',
      loading: true,
      fileUrl: ''
    };
  },
  methods: {
    // iframe 加载完成后关闭加载遮罩
    handleIframeLoad() {
      this.loading = false;
    }
  },
  mounted() {
    // 兜底超时：避免 iframe 加载异常导致遮罩一直显示
    setTimeout(() => {
      this.loading = false;
    }, 15000);
    getContractFile({
      C_SIGNFLOW_ID: this.$route.query.id
    }).then(res => {
      if (res.CODE == 200) {
        // 将下载地址拼入 pdfjs 预览地址，内嵌到 iframe 中展示
        this.fileUrl =
          'https://center.huafeng.com/ext/fileview/pdfjs/web/viewer.html?file=' +
          encodeURIComponent(res.DATA.C_FILE_DOWN_URL);
      } else {
        this.loading = false;
        Toast(res.MESSAGE);
      }
    });
  }
};
</script>

<style lang="less" scoped>
.contractFile {
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.pdf-wrap {
  flex: 1;
  position: relative;
  background: #f7f8fa;
}

.pdf-iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.loading-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f7f8fa;
  z-index: 1;
}
</style>
